<template>
  <div class="total mb-3">
    <b-icon icon="people-fill" />
      {{ models.length }} 人
  </div>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'members'
    }
  },

  computed: {
    models () {
      const members = this.$store.getters[`${this.modelName}/getAttr`]('models')
      if (members.length === 0) return []
      return members
    }
  }
}
</script>

<style lang="scss" scoped>
.total {
  font-size: 1.2rem;
  font-weight: 500;
}
</style>
